import { upperFirst } from "lodash-es"
import { type Ref } from "vue"
import { formFocusHack } from "@/helper/form-helper"

export function handleNamesForInitialText(
  model: Ref<any>,
  text: string,
  inputFirstName: Ref<any>,
  inputLastName: Ref<any>
) {
  const [first, second, third, fourth] = text.split(" ")
  if (first) {
    model.value.firstName = upperFirst(first)
  }
  /* Handle last name cases up to four words. */
  if (fourth) {
    // e.g. 'van der Zanden'
    model.value.lastName = `${second} ${third} ${upperFirst(fourth)}`
  } else if (third) {
    // e.g. 'van Zanden'
    model.value.lastName = `${second} ${upperFirst(third)}`
  } else if (second) {
    // e.g. 'Zanden'
    model.value.lastName = upperFirst(second)
  }

  /* Set focus accordingly. */
  if (model.value.lastName) {
    formFocusHack(inputLastName, model, "lastName")
  } else {
    formFocusHack(inputFirstName, model, "firstName")
  }
}
